'use client';

import EntryRevalidator from '@/components/EntryRevalidator';
import DefaultLayout, { type DefaultLayoutProps } from '../DefaultLayout';
import type { Revalidation } from './revalidation';

export default function RevalidatedDefaultLayout({
  uri,
  revalidate = true,
  entry,
  ...props
}: DefaultLayoutProps & Revalidation) {
  return (
    <EntryRevalidator {...{ uri, entry, enabled: revalidate }}>
      {(fresh) => <DefaultLayout {...props} entry={fresh} />}
    </EntryRevalidator>
  );
}
